/*--------------------------------------------------------------
# Archive Taxonomy Filters scripts
--------------------------------------------------------------*/

/**
 * UI of the filters form: the collapsible filter groups (a panel in the sidebar layout and on
 * small screens, dropdowns in the top bar layout on wide screens), searching the terms of a
 * filter, selected counts, the chips of the applied filters, the mobile panel and "clear filters".
 *
 * Loading the results without a page reload lives in realtime.js.
 */
document.addEventListener("DOMContentLoaded", function () {
  var filterBlocks = document.querySelectorAll(
    ".js-board-archive-taxonomy-filters",
  );
  var desktopMediaQuery = window.matchMedia("(min-width: 992px)");

  if (!filterBlocks.length) {
    return;
  }

  var escapeHtml = function (value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      var map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };

      return map[character] || character;
    });
  };

  var getFilterCheckboxes = function (container, onlyChecked) {
    return container.querySelectorAll(
      '[data-board-filter] input[type="checkbox"]' +
        (onlyChecked ? ":checked" : ""),
    );
  };

  /** Top bar layout on a wide screen: the groups open as dropdowns, one at a time. */
  var isDropdownMode = function (filterBlock) {
    return (
      filterBlock.dataset.boardArchiveLayout === "topbar" &&
      desktopMediaQuery.matches
    );
  };

  var updateSelectedCount = function (filter) {
    var selectedCountElement = filter.querySelector(
      "[data-board-filter-selected-count]",
    );
    var count = filter.querySelectorAll(
      'input[type="checkbox"]:checked',
    ).length;

    filter.dataset.hasSelection = count > 0 ? "1" : "0";

    if (selectedCountElement) {
      selectedCountElement.textContent = count;
      selectedCountElement.classList.toggle("is-visible", count > 0);
    }
  };

  var updateMobileActiveCount = function (filterBlock) {
    var activeCountElement = filterBlock.querySelector(
      "[data-board-mobile-active-count]",
    );
    if (!activeCountElement) {
      return;
    }

    var count = getFilterCheckboxes(filterBlock, true).length;

    activeCountElement.textContent = count;
    activeCountElement.classList.toggle("is-visible", count > 0);
  };

  var updateActiveFiltersSummary = function (filterBlock) {
    var summary = filterBlock.querySelector("[data-board-active-filters-summary]");
    if (!summary) {
      return;
    }

    var activeGroups = 0;
    filterBlock
      .querySelectorAll("[data-board-filter]")
      .forEach(function (filter) {
        if (filter.querySelector('input[type="checkbox"]:checked')) {
          activeGroups += 1;
        }
      });

    var label =
      activeGroups === 1
        ? summary.dataset.labelSingular
        : summary.dataset.labelPlural;
    summary.textContent = (label || "%s").replace("%s", activeGroups);
  };

  var updateClearAllVisibility = function (filterBlock) {
    var hasSelection = getFilterCheckboxes(filterBlock, true).length > 0;

    filterBlock
      .querySelectorAll("[data-board-clear-all-filters]")
      .forEach(function (clearAllButton) {
        clearAllButton.classList.toggle("is-visible", hasSelection);
      });
  };

  /** One chip per checked term, in the order of the filters. */
  var updateChips = function (filterBlock) {
    var row = filterBlock.querySelector("[data-board-active-filters]");
    var chips = filterBlock.querySelector("[data-board-active-chips]");
    if (!row || !chips) {
      return;
    }

    var html = "";
    getFilterCheckboxes(filterBlock, true).forEach(function (checkbox) {
      var option = checkbox.closest(".js-board-filter-option");
      var nameElement = option
        ? option.querySelector(".board-archive-filter-option__name")
        : null;
      var name = nameElement ? nameElement.textContent.trim() : checkbox.value;
      var taxonomy = (checkbox.name.match(/^bf\[([^\]]+)\]/) || [])[1] || "";

      html +=
        '<button type="button" class="board-archive-filter-chip" data-board-remove-filter' +
        ' data-filter-taxonomy="' +
        escapeHtml(taxonomy) +
        '" data-term-id="' +
        escapeHtml(checkbox.value) +
        '" aria-label="' +
        escapeHtml((row.dataset.removeLabel || "Remove filter %s").replace("%s", name)) +
        '">' +
        '<span class="board-archive-filter-chip__label">' +
        escapeHtml(name) +
        "</span>" +
        '<span class="board-archive-filter-chip__remove" aria-hidden="true"></span>' +
        "</button>";
    });

    chips.innerHTML = html;
    row.hidden = html === "";
  };

  var filterTermOptions = function (filter, query) {
    var trimmedQuery = (query || "").trim();
    var normalizedQuery = trimmedQuery.toLowerCase();
    var options = filter.querySelectorAll(".js-board-filter-option");
    var emptyState = filter.querySelector(".js-board-filter-empty");
    var resultsLabel = filter.querySelector(".js-board-filter-results-label");
    var visibleCount = 0;

    options.forEach(function (option) {
      var optionLabel = (option.dataset.termLabel || "").toLowerCase();
      var isVisible =
        !normalizedQuery || optionLabel.indexOf(normalizedQuery) !== -1;
      option.hidden = !isVisible;
      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (emptyState) {
      if (trimmedQuery.length > 0 && visibleCount === 0) {
        var taxonomyPluralLabel = (
          emptyState.dataset.taxonomyPluralLabel || "terms"
        ).toLowerCase();
        emptyState.textContent =
          "No " +
          taxonomyPluralLabel +
          ' found matching "' +
          trimmedQuery +
          '"';
        emptyState.hidden = false;
      } else {
        emptyState.textContent = "";
        emptyState.hidden = true;
      }
    }

    if (resultsLabel) {
      if (trimmedQuery.length > 0) {
        resultsLabel.innerHTML =
          visibleCount +
          " results for <strong>'" +
          escapeHtml(trimmedQuery) +
          "'</strong>";
        resultsLabel.hidden = false;
      } else {
        resultsLabel.innerHTML = "";
        resultsLabel.hidden = true;
      }
    }
  };

  var setGroupExpanded = function (group, isExpanded) {
    var toggle = group.querySelector("[data-board-filter-group-toggle]");
    var body = toggle
      ? document.getElementById(toggle.getAttribute("aria-controls"))
      : null;

    if (!toggle || !body) {
      return;
    }

    toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    group.classList.toggle("is-collapsed", !isExpanded);
    body.hidden = !isExpanded;

    if (isExpanded) {
      var searchInput = group.querySelector(".js-board-filter-search");
      if (searchInput && isDropdownMode(group.closest(".js-board-archive-taxonomy-filters"))) {
        window.setTimeout(function () {
          searchInput.focus();
        }, 50);
      }
    }
  };

  /**
   * Starting state of a group: dropdowns start closed, the sidebar panel on a wide screen
   * starts open, and the mobile panel opens only the groups with a selection.
   */
  var applyDefaultGroupState = function (filterBlock, group) {
    if (isDropdownMode(filterBlock)) {
      setGroupExpanded(group, false);
    } else if (desktopMediaQuery.matches) {
      setGroupExpanded(group, true);
    } else {
      setGroupExpanded(group, group.dataset.hasSelection === "1");
    }
  };

  filterBlocks.forEach(function (filterBlock) {
    var filters = filterBlock.querySelectorAll("[data-board-filter]");
    var mobileToggleButton = filterBlock.querySelector(
      "[data-board-mobile-filters-toggle]",
    );
    var chipsRow = filterBlock.querySelector("[data-board-active-filters]");

    var refreshState = function () {
      filters.forEach(updateSelectedCount);
      updateMobileActiveCount(filterBlock);
      updateActiveFiltersSummary(filterBlock);
      updateClearAllVisibility(filterBlock);
      updateChips(filterBlock);
    };

    var closeAllGroups = function (except) {
      filters.forEach(function (filter) {
        if (filter !== except) {
          setGroupExpanded(filter, false);
        }
      });
    };

    /**
     * Uncheck every term (and empty the term searches). Each unchecked box fires a
     * bubbling `change` event, so realtime.js reloads the results once afterwards.
     */
    var clearAllFilters = function () {
      filters.forEach(function (filter) {
        var filterSearchInput = filter.querySelector(".js-board-filter-search");

        filter
          .querySelectorAll('input[type="checkbox"]:checked')
          .forEach(function (checkbox) {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event("change", { bubbles: true }));
          });

        if (filterSearchInput) {
          filterSearchInput.value = "";
          filterTermOptions(filter, "");
        }
      });

      refreshState();
    };

    var setMobilePanelOpen = function (isOpen) {
      filterBlock.classList.toggle("is-mobile-filters-open", isOpen);
      if (mobileToggleButton) {
        mobileToggleButton.setAttribute(
          "aria-expanded",
          isOpen ? "true" : "false",
        );
      }
    };

    if (mobileToggleButton) {
      mobileToggleButton.addEventListener("click", function () {
        setMobilePanelOpen(
          !filterBlock.classList.contains("is-mobile-filters-open"),
        );
      });
    }

    // The "×" in the corner of the mobile panel.
    filterBlock
      .querySelectorAll("[data-board-mobile-filters-close]")
      .forEach(function (closeButton) {
        closeButton.addEventListener("click", function () {
          setMobilePanelOpen(false);
        });
      });

    filters.forEach(function (filter) {
      var toggle = filter.querySelector("[data-board-filter-group-toggle]");
      var searchInput = filter.querySelector(".js-board-filter-search");

      if (toggle) {
        toggle.addEventListener("click", function () {
          var willExpand = toggle.getAttribute("aria-expanded") !== "true";
          if (willExpand && isDropdownMode(filterBlock)) {
            closeAllGroups(filter);
          }
          setGroupExpanded(filter, willExpand);
        });
      }

      if (searchInput) {
        searchInput.addEventListener("input", function (event) {
          filterTermOptions(filter, event.target.value);
        });
        // Enter inside a term search must not submit the form.
        searchInput.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
          }
        });
      }

      filterTermOptions(filter, "");
      applyDefaultGroupState(filterBlock, filter);
    });

    // Dropdowns close on a click outside them and on Escape.
    document.addEventListener("click", function (event) {
      if (!isDropdownMode(filterBlock)) {
        return;
      }
      filters.forEach(function (filter) {
        if (!filter.contains(event.target)) {
          setGroupExpanded(filter, false);
        }
      });
    });
    filterBlock.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isDropdownMode(filterBlock)) {
        closeAllGroups(null);
      }
    });

    desktopMediaQuery.addEventListener("change", function () {
      filters.forEach(function (filter) {
        applyDefaultGroupState(filterBlock, filter);
      });
    });

    filterBlock.addEventListener("change", function (event) {
      if (event.target.matches('[data-board-filter] input[type="checkbox"]')) {
        refreshState();
      }
    });

    if (chipsRow) {
      chipsRow.addEventListener("click", function (event) {
        var chip = event.target.closest("[data-board-remove-filter]");
        if (!chip) {
          return;
        }

        event.preventDefault();
        var checkbox = filterBlock.querySelector(
          'input[type="checkbox"][name="bf[' +
            chip.dataset.filterTaxonomy +
            '][]"][value="' +
            chip.dataset.termId +
            '"]',
        );
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    filterBlock
      .querySelectorAll("[data-board-clear-all-filters]")
      .forEach(function (clearAllButton) {
        clearAllButton.addEventListener("click", function (event) {
          event.preventDefault();
          clearAllFilters();
        });
      });

    // Lets realtime.js (e.g. the "no results" reset button) clear the filters.
    filterBlock.addEventListener("board:archive-filters-clear", clearAllFilters);

    refreshState();
  });
});
